import { useState } from "react";
import { AlertTriangle } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";

const LABELS = {
  use_document: "Use document amount", mine_more_current: "My number is more current", not_sure: "I'm not sure",
  ask_specialist: "Ask a specialist", update_status: "Yes, update my case status", keep_answer: "Keep my earlier answer",
  use_calculated: "Use the calculated estimate", mark_behind: "I'm behind", mark_current: "I'm current",
};

export const ConflictCard = ({ c, onResolved }) => {
  const [busy, setBusy] = useState(false);
  const pick = async (choice) => {
    setBusy(true);
    try {
      const { data } = await api.post("/case/resolve", { conflict_id: c.id, choice });
      toast.success("Thanks — your review has been updated.");
      onResolved?.(data.analysis);
    } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <div data-testid={`conflict-${c.id}`} className="rise rounded-2xl border-2 border-red-200 bg-red-50/70 p-5">
      <div className="mb-2 flex items-center gap-2 font-display font-bold text-red-800">
        <AlertTriangle className="h-5 w-5" /> {c.kind === "timeline" ? "This may change your urgency" : "Let's double-check this"}
      </div>
      <p className="text-[15px] leading-relaxed text-slate-800">{c.message}</p>
      <div className="mt-4 flex flex-wrap gap-2">
        {c.options.map((o) => (
          <button key={o} disabled={busy} data-testid={`conflict-${c.id}-${o}`} onClick={() => pick(o)}
            className="tap rounded-full border-2 border-slate-900 bg-white px-4 py-2 text-sm font-bold uppercase tracking-wide hover:bg-slate-900 hover:text-white disabled:opacity-50">
            {LABELS[o] || o}
          </button>
        ))}
      </div>
    </div>
  );
};
